import React from 'react';
import { Grid, MenuItem, Typography } from '@mui/material';

const ProfileCompletionScore = ({ profileCompletionScore }) => {
  const greenPercentage = Math.min(profileCompletionScore, 100);
  const lightBluePercentage = 100 - greenPercentage;

  const progressStyles = {
    width: '100px',
    height: '100px',
    borderRadius: '50%',
    border: `8px solid lightblue`,
    position: 'relative',
  };

  const greenStyles = {
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    backgroundImage: `conic-gradient(green ${greenPercentage}%, white ${greenPercentage}% 100%)`,
    position: 'absolute',
    top: 0,
    left: 0,
  };

  const textStyles = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    color: 'black',
    fontWeight: 'bold',
  };

  return (
    <div style={progressStyles}>
      <div style={greenStyles}></div>
      <Typography variant="body2" style={textStyles}>
        {profileCompletionScore}%
      </Typography>
    </div>
  );
};

export default ProfileCompletionScore;